export const creators = [
  {
    name: "Courtland Allen",
    business: "Indie Hackers",
    img:
      "https://cdn.convertkit.com/assets/images/creators/courtland-allen.jpeg"
  },
  {
    name: "Drew Holcomb",
    business: "Musician",
    img: "https://cdn.convertkit.com/assets/images/creators/drew-holcomb.jpg"
  },
  {
    name: "Aileen Xu",
    business: "YouTuber",
    img: "https://cdn.convertkit.com/assets/images/creators/aileen-xu.jpg"
  },
  {
    name: "Gabby Beckford",
    business: "Travel Blogger",
    img: "https://cdn.convertkit.com/assets/images/creators/gabby-beckford.jpg"
  },
  {
    name: "Tori Mistick",
    business: "Podcaster",
    img: "https://cdn.convertkit.com/assets/images/creators/tori-mistick.jpg"
  }
]

export const getCreator = () =>
  creators[Math.floor(Math.random() * creators.length)]
